import React from 'react';

/** Multi-colour Google "G" mark. */
export function GoogleIcon({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="#4285F4"
        d="M22.5 12.2c0-.7-.06-1.4-.18-2.06H12v3.9h5.9a5.05 5.05 0 0 1-2.19 3.32v2.75h3.54c2.07-1.9 3.25-4.72 3.25-7.91z"
      />
      <path
        fill="#34A853"
        d="M12 23c2.94 0 5.42-.98 7.22-2.64l-3.54-2.75c-.98.66-2.24 1.05-3.68 1.05-2.83 0-5.23-1.91-6.09-4.49H2.26v2.84A11 11 0 0 0 12 23z"
      />
      <path
        fill="#FBBC05"
        d="M5.91 14.17a6.6 6.6 0 0 1 0-4.34V6.99H2.26a11 11 0 0 0 0 9.02l3.65-2.84z"
      />
      <path
        fill="#EA4335"
        d="M12 5.34c1.6 0 3.03.55 4.16 1.62l3.12-3.12A11 11 0 0 0 12 1 11 11 0 0 0 2.26 6.99l3.65 2.84C6.77 7.25 9.17 5.34 12 5.34z"
      />
    </svg>
  );
}

/** Meta "infinity" mark, single-colour so it reads on the light button. */
export function MetaIcon({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="#0866FF"
        d="M6.6 6.2C4.3 6.2 2.7 8.4 2.7 12s1.6 5.8 3.7 5.8c1.4 0 2.4-.8 3.8-3l1.2-2 .9 1.6c1.6 2.7 2.7 3.4 4.3 3.4 2.2 0 3.7-2.2 3.7-5.9 0-3.7-1.6-5.7-3.8-5.7-1.5 0-2.7.9-4 3.2l-.6 1-.7-1.2C13.5 7 12.3 6.2 10.7 6.2c-.3 0-.5 0-.8.1.1 0-1.6-.1-3.3-.1zm.3 2.2c.9 0 1.6.6 2.5 2.1l.7 1.2-.9 1.5C8.2 15 7.7 15.4 7 15.4c-1 0-1.7-1.2-1.7-3.3 0-2.2.7-3.5 1.6-3.7zm10.1 0c1 0 1.7 1.3 1.7 3.5 0 2.1-.6 3.4-1.6 3.4-.8 0-1.3-.5-2.2-2l-1-1.7.8-1.3c.9-1.4 1.6-1.9 2.3-1.9z"
      />
    </svg>
  );
}
